import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IndicatorTile from './IndicatorTile'
import UUID from 'uuid'

class IndicatorPanel extends Component {


	getIndicators = () => {
		return this.props.datas.map((data) => {
			return (<IndicatorTile key={ UUID.v4() }
								   title={ data.title }
								   titlePosition={ data.titlePosition }
								   number={ data.number }
								   text={ data.text }
			/>)
		})
	}

	render() {
		return (
			<div key={ UUID.v4() } className='row no-margin'>
				<div className='col s12 no-padding'>
					{ this.getIndicators() }
				</div>
			</div>
		)
	}
}

IndicatorPanel.propTypes = {
	datas: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string.isRequired,
		titlePosition: PropTypes.string,
		size: PropTypes.number.isRequired,
		number: PropTypes.number,
		text: PropTypes.string
	}))
}

IndicatorPanel.defaultProps = {
	datas: []
}

export default IndicatorPanel



// WEBPACK FOOTER //
// ./src/dashboard/components/indicator/IndicatorPanel.js